import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS } from '@modules/affiliate-program-commissions/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  ICommissionsConstantsResponse,
} from '../types';
import {
  AFFILIATE_PROGRAM_COMMISSIONS_CONSTANTS_QUERY_KEY,
  AFFILIATE_PROGRAM_COMMISSIONS_CONSTANTS_URL,
} from '../constants';

export default function useAffiliateProgramCommissionsConstantsQuery(): IContextQueryResult<ICommissionsConstantsResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ICommissionsConstantsResponse>({
    queryKey: [AFFILIATE_PROGRAM_COMMISSIONS_CONSTANTS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<ICommissionsConstantsResponse>(
      AFFILIATE_PROGRAM_COMMISSIONS_CONSTANTS_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.EDIT,
      },
    ),
  });
}
